/**
 * Merge INDIGO_RECOMMENDATION_TYPES (Snowflake) and HEATHER_RECOMMENDATION_TYPES (Shopify)
 * into a single badge list for the UI.
 *
 * HEATHERS_PICK is stripped from the Indigo side — Shopify is the source of truth.
 */
export const mergeRecommendationTypes = (book: any): string[] | undefined => {
  const merged: string[] = [];
  const indigo = book.indigo_recommendation_types || book.INDIGO_RECOMMENDATION_TYPES;
  if (Array.isArray(indigo)) {
    merged.push(...indigo.filter((t: string) => t !== 'HEATHERS_PICK'));
  } else if (typeof indigo === 'string' && indigo.trim()) {
    merged.push(
      ...indigo
        .split(',')
        .map((t: string) => t.trim())
        .filter((t: string) => t && t !== 'HEATHERS_PICK')
    );
  }
  const heather = book.heather_recommendation_types || book.HEATHER_RECOMMENDATION_TYPES;
  if (Array.isArray(heather)) {
    merged.push(...heather);
  } else if (typeof heather === 'string' && heather.trim()) {
    merged.push(
      ...heather
        .split(',')
        .map((t: string) => t.trim())
        .filter(Boolean)
    );
  }
  return merged.length > 0 ? merged : undefined;
};
